import { render, staticRenderFns } from "./topDrivers.vue?vue&type=template&id=317782fe&scoped=true&"
import script from "./topDrivers.vue?vue&type=script&lang=js&"
export * from "./topDrivers.vue?vue&type=script&lang=js&"
import style0 from "./topDrivers.vue?vue&type=style&index=0&id=317782fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317782fe",
  null
  
)

export default component.exports